import { connect } from 'react-redux';
import React, { Component } from 'react';

const div1 = {
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	height: "inherit",
	padding: "3px"
}

const div2 = {
	width: "80%",
	height: "80%",
	background: "#fff",
	boxShadow: "15px 15px 25px #ccc",
	borderRadius: "15px"
}
class welcomePage extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidMount() {
		if (this.props.auth.user.position === 'Admin') {
			this.props.history.push('/adminPanel')
		}
	}

	render() {
		// eslint-disable-next-line
		const intern = <div>Hvala ti što učestvuješ u ovogodišnjem programu lideri generacije 2023.
			<br />
			Pred tobom se nalaze 4 testa kojima možeš pristupiti klikom na ime testa u sidebaru.
			<br />
			Ukoliko imaš neki problem ili nedoumicu slobodno nas kontaktiraj na mail {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}</div>

		const regular = <div>Hvala ti što si zainteresovan za radu u kompaniji Galeb.
			<br />
			Pred tobom se nalaze 2 testa kojima možeš pristupiti klikom na ime testa u sidebaru.
			<br />
			Ukoliko imaš neki problem ili nedoumicu slobodno nas kontaktiraj na mail {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}</div>
		return (
			<div className="Content">
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br /><br />
								Zdravo {this.props.auth.user.name},
								<br /><br />
								{regular}
								<br />
								<br />
								Srećno na testovima.
								<br /><br />
								Galeb
							</div>
						</div>
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(welcomePage);